module.exports = __webpack_public_path__ + "static/media/logo.843fb076.png";